import { createModel } from '@rematch/core';
import { RootModel } from './RootState';

export type ProductsGridState = {
    highlightedProductId?: string;
};

export const initialState: ProductsGridState = {
    highlightedProductId: undefined
};

export const productsGridState = createModel<RootModel>()({
    state: initialState,
    reducers: {
        setHighlightedProductId(state, productId?: string) {
            return {
                ...state,
                highlightedProductId: productId
            };
        },
        reset() {
            return {
                ...initialState
            };
        },
        setExpiredAt(state, expiredAt: string) {
            return { ...state, expiredAt };
        }
    }
});
